import React from 'react'
import "./logotip.css";

const Logotip = () => {
  return (
    <a id='logotip' href="/">
      <h1>THE PLANETS</h1>
    </a>
  )
}

export default Logotip
